<template>
  <fragment>
    <section
      class="team section center-content"
      :class="[
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
      ]"
    >
      <div class="container">
        <div class="team-inner section-inner">
          <c-section-header :data="teamHeader" class="center-content reveal-from-bottom" />
          <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
            
            <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/michael.jpg')"
                      alt="Team member 01"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.michl.name") }}</h5>
                  <div class="team-item-role text-xs fw-600 mb-8">{{ $t("about.michl.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div>

	    <div
              class="tiles-item reveal-from-bottom"
              data-reveal-container=".tiles-wrap"
              data-reveal-delay="150"
            >
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/raquel.jpeg')"
                      alt="Team member 02"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.raquel.name") }}</h5>
                  <div class="team-item-role text-xs fw-600 mb-8">{{ $t("about.raquel.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div>

	    <div
              class="tiles-item reveal-from-bottom"
              data-reveal-container=".tiles-wrap"
              data-reveal-delay="300"
            >
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/niklas.jpeg')"
                      alt="Team member 03"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.niklas.name") }}</h5>
                  <div class="team-item-role text-xs fw-600 mb-8">{{ $t("about.niklas.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div>

            <!--div
              class="tiles-item reveal-from-bottom"
              data-reveal-container=".tiles-wrap"
              data-reveal-delay="150"
            >
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/sv.jpg')"
                      alt="Team member 02"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.basti.name") }}</h5>
                  <div class="team-item-role text-xs fw-600 mb-8">{{ $t("about.basti.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div-->

            <!--div
              class="tiles-item reveal-from-bottom"
              data-reveal-container=".tiles-wrap"
              data-reveal-delay="300"
            >
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/mjw.jpg')"
                      alt="Team member 03"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.michael.name") }}</h5>
                  <div class="team-item-role text-xs fw-600 mb-8">{{ $t("about.michael.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div-->

            <!--div
              class="tiles-item reveal-from-bottom"
              data-reveal-container=".tiles-wrap"
              data-reveal-delay="450"
            >
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/bc.jpg')"
                      alt="Team member 04"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.bianca.name") }}</h5>
                  <div class="team-item-role text-xs fw-600 mb-8">{{ $t("about.bianca.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div-->

            <!--div
              class="tiles-item reveal-from-bottom"
              data-reveal-container=".tiles-wrap"
              data-reveal-delay="600"
            >
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/ck.jpg')"
                      alt="Team member 05"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.chris.name") }}</h5>
                  <div class="team-item-role text-xs fw-600 mb-8">{{ $t("about.chris.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div-->

            <!--div
              class="tiles-item reveal-from-bottom"
              data-reveal-container=".tiles-wrap"
              data-reveal-delay="750"
            >
              <div class="tiles-item-inner">
                <div class="team-item-header">
                  <div class="team-item-image mb-24">
                    <c-image
                      :src="require('@/assets/images/mm.jpg')"
                      alt="Team member 06"
                      :width="180"
                      :height="180"
                    />
                  </div>
                </div>
                <div class="team-item-content">
                  <h5 class="team-item-name mt-0 mb-4">{{ $t("about.marina.name") }}</h5>
                  <div
                    class="team-item-role text-xs fw-600 mb-8"
                  >{{ $t("about.marina.position") }}</div>
                  <p class="m-0 text-sm"></p>
                </div>
              </div>
            </div-->
          </div>
          <c-button
            tag="a"
            color="primary"
            wide-mobile
            href="mailto:team@campuskraft.com"
            class="mt-32"
          >{{ $t("employer.secondaryAction") }}</c-button>
        </div>
      </div>
    </section>
  </fragment>
</template>

<script>
import CLayout from "@/layouts/LayoutAlternative.vue";
import CImage from "@/components/elements/Image.vue";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CButton from "@/components/elements/Button.vue";

export default {
  name: "Employer",
  components: {
    CImage,
    CSectionHeader,
    CButton,
  },
  data() {
    return {
      nameField: "",
      emailField: "",
      messageField: "",
    };
  },
  mixins: [SectionTilesProps],
  computed: {
    sectionHeader() {
      return {
        paragraph: this.$i18n.t("about.bayme"),
      };
    },
    teamHeader() {
      return {
        title: this.$i18n.t("about.title"),
        paragraph: this.$i18n.t("about.subtitle"),
      };
    },
    contactHeader() {
      return {
        title: this.$i18n.t("about.title"),
        paragraph: this.$i18n.t("about.subtitle"),
      };
    },
    yourName() {
      return this.$i18n.t("about.contact.name");
    },
    yourEmail() {
      return this.$i18n.t("about.contact.email");
    },
    yourMessage() {
      return this.$i18n.t("about.contact.message");
    },
  },
  created() {
    this.$emit("update:layout", CLayout);
  },
  methods: {
    sendMessage() {
      window.open(
        `mailto:team@campuskraft.com?subject=Anfrage&body=${this.messageField}`
      );
      // entweder mandrill npm packege
      // ODER: window.open('mailto:test@example.com?subject=subject&body=body');
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-action {
  width: 100%;
}
.contact-image {
  width: 70% !important;
  max-width: 70% !important;
  border-radius: 4px;
}
</style>
